/* eslint-disable id-length, @typescript-eslint/naming-convention  --
 * `t` is the standard i18next translation function name (id-length).
 * Rate limit error keys intentionally mirror backend SCREAMING_SNAKE_CASE error codes (naming-convention).
 */
function getRateLimitErrorMessage(t) {
    const RATE_LIMIT_ERROR_MESSAGES = {
        // RATE_LIMIT_BREACHED error messages
        RATE_LIMIT_BREACHED_GENERATE_IMAGE_TITLE: t("error:rateLimit.breached.generateImage.title"),
        RATE_LIMIT_BREACHED_GENERATE_IMAGE_MESSAGE: t("error:rateLimit.breached.generateImage.message"),
        RATE_LIMIT_BREACHED_CHAT_PAID: t("error:rateLimit.breached.chatPaid"),
        RATE_LIMIT_BREACHED_CHAT_FREE: t("error:rateLimit.breached.chatFree"),
        RATE_LIMIT_BREACHED_CHAT_GUEST: t("error:rateLimit.breached.chatGuest"),
        RATE_LIMIT_BREACHED_UPLOAD_USER_IMAGE: t("error:rateLimit.breached.uploadUserImage"),
        RATE_LIMIT_BREACHED_CREATE_CHATBOT: t("error:rateLimit.breached.createChatbot"),
        RATE_LIMIT_BREACHED_TRANSLATE_CHATBOT: t("error:rateLimit.breached.translateChatbot"),
        RATE_LIMIT_BREACHED_REPORT_CHATBOT: t("error:rateLimit.breached.reportChatbot"),
        RATE_LIMIT_BREACHED_SUBSCRIBE: t("error:rateLimit.breached.subscribe"),
        RATE_LIMIT_BREACHED_SUGGEST_FIELD: t("error:rateLimit.breached.suggestField"),
        RATE_LIMIT_BREACHED_SUGGEST_TAGS: t("error:rateLimit.breached.suggestTags"),
        RATE_LIMIT_BREACHED_PLAY_MESSAGE_AUDIO: t("error:rateLimit.breached.playMessageAudio"),
        // TIME_UNIT_MUST_BE_DEFINED error messages
        TIME_UNIT_MUST_BE_DEFINED_GENERATE_IMAGE: t("error:rateLimit.timeUnitMustBeDefined.generateImage"),
        TIME_UNIT_MUST_BE_DEFINED_CHAT: t("error:rateLimit.timeUnitMustBeDefined.chat"),
        TIME_UNIT_MUST_BE_DEFINED_UPLOAD_USER_IMAGE: t("error:rateLimit.timeUnitMustBeDefined.uploadUserImage"),
        TIME_UNIT_MUST_BE_DEFINED_CREATE_CHATBOT: t("error:rateLimit.timeUnitMustBeDefined.createChatbot"),
        TIME_UNIT_MUST_BE_DEFINED_TRANSLATE_CHATBOT: t("error:rateLimit.timeUnitMustBeDefined.translateChatbot"),
        TIME_UNIT_MUST_BE_DEFINED_REPORT_CHATBOT: t("error:rateLimit.timeUnitMustBeDefined.reportChatbot"),
        TIME_UNIT_MUST_BE_DEFINED_SUBSCRIBE: t("error:rateLimit.timeUnitMustBeDefined.subscribe"),
        TIME_UNIT_MUST_BE_DEFINED_SUGGEST_FIELD: t("error:rateLimit.timeUnitMustBeDefined.suggestField"),
        TIME_UNIT_MUST_BE_DEFINED_SUGGEST_TAGS: t("error:rateLimit.timeUnitMustBeDefined.suggestTags"),
        TIME_UNIT_MUST_BE_DEFINED_PLAY_MESSAGE_AUDIO: t("error:rateLimit.timeUnitMustBeDefined.playMessageAudio"),
    };
    return RATE_LIMIT_ERROR_MESSAGES;
}
// eslint-disable-next-line import/prefer-default-export -- Named export preserves call sites and i18n static key extraction.
export { getRateLimitErrorMessage };
